/**
 * arbi-dev Supabase client. Uses the SAME storage adapter as arbi root
 * so the auth cookie scoped to .ironcladsupply.co is shared between
 * arbi.ironcladsupply.co and arbi-dev.ironcladsupply.co. ADR 38.
 *
 * The adapter source of truth is `src/lib/supabaseStorage.ts` at repo
 * root — relative-imported here per ADR 36 (sibling-apps pattern,
 * deferred shared-package promotion).
 */
import { createClient } from '@supabase/supabase-js';
import type { Database } from '../../../../src/lib/database.types';
import { createSupabaseStorage } from '../../../../src/lib/supabaseStorage';

const supabaseUrl: string | undefined = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey: string | undefined = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    '[arbi-dev] Supabase credentials not set. ' +
      'Vercel project arbi-isg-dev needs VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY ' +
      'configured under Settings → Environment Variables.'
  );
}

export const supabase = createClient<Database>(
  supabaseUrl ?? 'https://placeholder.supabase.co',
  supabaseAnonKey ?? 'placeholder',
  {
    auth: {
      storage: createSupabaseStorage(),
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  }
);

if (import.meta.env.DEV) (window as unknown as { supabase: typeof supabase }).supabase = supabase;
